export type ItemStatus = "unstarted" | "started" | "complete";

export type StatusMap = Record<string, ItemStatus>;

// mergeStatusMaps creates a new StatusMap with the combined key-value pairs
// of the passed-in StatusMaps. If a key appears in both inputs, the value
// representing the furthest progress is used (see furthestProgress below).
export function mergeStatusMaps(a: StatusMap, b: StatusMap): StatusMap {
    const merged: Record<string, ItemStatus> = {};
    for (const k of Object.keys({...a, ...(b as any)})) {
        merged[k] = furthestProgress(a[k], b[k]);
    }
    return merged;
}

// furthestProgress, given two ItemStatuses, returns whichever one
// represents the furthest progress on a content item, assuming the flow
// unstarted -> started -> complete. Null/undefined inputs are equivalent to
// "unstarted".
export function furthestProgress(
    a?: ItemStatus | null,
    b?: ItemStatus | null,
): ItemStatus {
    a = a || "unstarted";
    b = b || "unstarted";
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    return progressRank[a] > progressRank[b] ? a : b;
}

const progressRank: Partial<Record<ItemStatus, number>> = {
    unstarted: 0,
    started: 1,
    complete: 2,
};
